import cx from "classnames"
import { camelize } from "../../utils"
import type { IconColorsType } from "../"
export type IconProps = {
  color?: IconColorsType
  size?: 16 | 20 | 24 | 32
  contained?: boolean
  className?: string
}
const iconSource = "utilityVanLargeFilled"
const UtilityVanLargeFilledIcon = ({
  color,
  size = 24,
  contained = false,
  className,
}: IconProps) => {
  const computedClassName = cx(
    className,
    `cobalt-Icon cobalt-Icon--${iconSource}`,
    {
      [`c-fill-${camelize(color || "")}`]: color,
      "cobalt-Icon--size16": size === 16,
      "cobalt-Icon--size20": size === 20,
      "cobalt-Icon--size32": size === 32,
      "cobalt-Icon--contained": contained,
    },
  )
  return (
    <span className={computedClassName}>
      {
        <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24">
          <title>{iconSource}</title>
          <path d="M6 15C7.036 15 7.875 15.84 7.875 16.875S7.035 18.75 6 18.75 4.125 17.91 4.125 16.875 4.965 15 6 15M18.375 15C19.41 15 20.25 15.84 20.25 16.875S19.41 18.75 18.375 18.75 16.5 17.91 16.5 16.875 17.34 15 18.375 15" />
          <path d="M14.25 17.438H8.563Q8.624 17.165 8.625 16.875C8.625 15.425 7.45 14.25 6 14.25S3.375 15.425 3.375 16.875Q3.376 17.165 3.437 17.438H3C2.275 17.438 1.688 16.85 1.688 16.125V14.625H2.25C2.56 14.625 2.813 14.373 2.813 14.063S2.56 13.5 2.25 13.5H1.688V12.75H2.25C2.56 12.75 2.813 12.498 2.813 12.188S2.56 11.625 2.25 11.625H1.688V5.25C1.688 4.525 2.274 3.938 3 3.938H14.25zM16.984 6.938C17.827 6.938 18.586 7.45 18.9 8.234L19.942 10.842 21.587 11.665C22.03 11.887 22.313 12.342 22.313 12.839V13.5H21.75C21.44 13.5 21.188 13.752 21.188 14.063S21.439 14.625 21.75 14.625H22.313V16.125C22.313 16.85 21.725 17.438 21 17.438H20.939Q20.999 17.165 21 16.875C21 15.425 19.825 14.25 18.375 14.25S15.75 15.425 15.75 16.875Q15.751 17.165 15.812 17.438H15V10.688H18.67L17.854 8.652C17.713 8.296 17.367 8.062 16.985 8.062H15V6.938z" />
        </svg>
      }
    </span>
  )
}
export default UtilityVanLargeFilledIcon
